import { useTranslation } from 'react-i18next'

const AssetsNoResults = () => {
  const { t } = useTranslation('wallet', { keyPrefix: 'assetList' })

  return (
    <div className='flex flex-col items-center justify-center px-2 py-6 rounded bg-paper-muted text-center'>
      <div className='text-main-muted text-lg font-semibold'>
        {t('noAssets')}
      </div>
      <div className='mt-3 text-main-muted text-sm'>
        {t('noAssetsSuggestion')}
      </div>
    </div>
  )
}

export default AssetsNoResults
